import { cn } from "@utils";

const FormLabel = ({ children, htmlFor, className }) => {
  return (
    <label htmlFor={htmlFor}
      className={cn(
        "block text-sm/6 font-medium text-zinc-900",
        className
      )}
    >
      {children}
    </label>
  );
};

export default FormLabel;